import { actions as snackActions } from '../../actions/snack.actions'
import config from '@/config/env'

const { API_URL } = config
const EXCLUDED_PATHS = ['/user/login', '/user/refresh', '/user/logout']

export default {
  error: (auth, store) => async (error) => {
    const { dispatch } = store
    if (error.response) {
      if ([401, 403].includes(error.response.status)) {
        auth?.logout()
      } else {
        dispatch(snackActions.notify(error.response.data.mensaje))
      }
    } else {
      if (error.message === 'Network Error') {
        if (error.config?.url === API_URL + '/ctmprovisionalcustomer') {
          return
        }
        if (error?.config?.url?.includes(API_URL) && window.location.pathname !== '/servicedown') {
          if (store.getState().login?.iduser) {
            window.location.replace(window.location.protocol + '//' + window.location.host + '/servicedown')
          }
          dispatch(snackActions.notify('¡Mejoras en curso! 🛠️ Volvemos pronto con novedades!'))
        }
      } else {
        dispatch(snackActions.notify(error.message))
      }
    }
    return Promise.reject(error)
  },

  injecttoken: (auth) => async (config) => {
    const shouldExclude = EXCLUDED_PATHS.some((path) => config.url.includes(path))

    if (shouldExclude) {
      return config
    }
    const token = await auth.getValidAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ` + token
    }
    return config
  },
}
